<template>
	<div>
        <div class="row">
            <el-card class="pt-1 pb-0" shadow="always" :body-style="{ padding: '10px'}" style="width:100%;">
                <div class="row">
                    <div class="col-md-6">
                        <el-button size="mini" @click="$router.push('/performance-report/sales-volume')"><i class="fa fa-angle-left"></i></el-button>
                    </div>
                    <div class="col-md-6 text-right">
                        <el-button size="mini" @click="toggleFullscreen"><i :class="[toggleIcon ? 'fa-compress' : 'fa-arrows-alt', 'fa']"></i></el-button>
                        <el-button size="mini" @click="$router.push('/performance-report/konsolidasi')"><i class="fa fa-angle-right"></i></el-button>
                    </div>
                </div>

                <h4 class="text-center">LOSSES BY PRODUCT YTD MEI 2023</h4>

                <el-form  class="mt-2" label-position="top" label-width="100px">
                    <div class="row">
                        <div class="col-md-2">	
                            <el-form-item label="Tahun:" style="min-width:85px;">
                                <el-select v-model="year" clearable filterable placeholder="Select Year" size="medium" style="width:100%;">
                                    <el-option v-for="item3 in options.years" :key="item3.value" :label="item3.name" :value="item3.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-1">	
                            <el-form-item label=" ">
                                <el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply</el-button>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>

                <!-- :span-method="objectSpanMethod" -->
                <el-table
                    :data="tableData"
                    
                    stripe
                    border
                    style="width: 100%; font-size:12px;"
                    :header-cell-style="{paddingTop: '8px', paddingBottom: '2px', background: '#F5F7FA'}"
                    :header-row-style="{padding:'0px'}"
                    :cell-style="{padding: '8px 0px'}"   
                    class="mt-1">

                    <el-table-column
                        fixed
                        prop="type"
                        label="Type"
                        header-align="center"
                        width="120">
                    </el-table-column>

                    <el-table-column
                        fixed
                        prop="product"
                        label="Product"
                        header-align="center"
                        width="160">
                    </el-table-column>

                    <el-table-column
                        label="Real 2023"
                        header-align="center">
                        <el-table-column
                            label="Vol. Sales (L)"
                            header-align="center">
                            <el-table-column
                                prop="real_current_year_vol_sales"
                                label="A"
                                header-align="center"
                                :width="columnWidth"
                                align="right">
                            </el-table-column>
                        </el-table-column>

                        <el-table-column
                            label="Vol. Losses (L)"
                            header-align="center">
                            <el-table-column
                                prop="real_current_year_vol_losses"
                                label="B"
                                header-align="center"
                                :width="columnWidth"
                                align="right">
                            </el-table-column>
                        </el-table-column>

                        <el-table-column
                            label="Losses Value (Rp)"
                            header-align="center">
                            <el-table-column
                                prop="real_current_year_losses_value"
                                label="C"
                                header-align="center"
                                :width="columnWidth"
                                align="right">
                            </el-table-column>
                        </el-table-column>

                        <el-table-column
                            label="% Losses"
                            header-align="center">
                            <el-table-column
                                prop="real_current_year_losses_percentage"
                                label="D"
                                header-align="center"
                                :width="columnWidth"
                                align="right">
                            </el-table-column>
                        </el-table-column>

                    </el-table-column>

                    <el-table-column
                        label="Real 2022"
                        header-align="center">
                        <el-table-column
                            label="Vol. Sales (L)"
                            header-align="center">
                            <el-table-column
                                prop="real_prev_year_vol_sales"
                                label="E"
                                header-align="center"
                                :width="columnWidth"
                                align="right">
                            </el-table-column>
                        </el-table-column>

                        <el-table-column
                            label="Vol. Losses (L)"
                            header-align="center">
                            <el-table-column
                                prop="real_prev_year_vol_losses"
                                label="F"
                                header-align="center"
                                :width="columnWidth"
                                align="right">
                            </el-table-column>
                        </el-table-column>

                        <el-table-column
                            label="Losses Value (Rp)"
                            header-align="center">
                            <el-table-column
                                prop="real_prev_year_losses_value"
                                label="G"
                                header-align="center"
                                :width="columnWidth"
                                align="right">
                            </el-table-column>
                        </el-table-column>

                        <el-table-column
                            label="% Losses"
                            header-align="center">
                            <el-table-column
                                prop="real_prev_year_losses_percentage"
                                label="H"
                                header-align="center"
                                :width="columnWidth"
                                align="right">
                            </el-table-column>
                        </el-table-column>

                    </el-table-column>

                    <el-table-column
                        label="YoY 2023 vs 2022 (%)"
                        header-align="center">
                        <el-table-column
                            label="Vol. Sales (L)"
                            header-align="center">
                            <el-table-column
                                prop="yoy_vs_year_vol_sales"
                                label="I=A:E"
                                header-align="center"
                                :width="columnWidth"
                                align="right">
                            </el-table-column>
                        </el-table-column>

                        <el-table-column
                            label="Vol. Losses (L)"
                            header-align="center">
                            <el-table-column
                                prop="yoy_vs_year_vol_losses"
                                label="J=B:F"
                                header-align="center"
                                :width="columnWidth"
                                align="right">
                            </el-table-column>
                        </el-table-column>

                        <el-table-column
                            label="Losses Value (Rp)"
                            header-align="center">
                            <el-table-column
                                prop="yoy_vs_year_vol_losses_value"
                                label="K=C:G"
                                header-align="center"
                                :width="columnWidth"
                                align="right">
                            </el-table-column>
                        </el-table-column>

                        <el-table-column
                            label="% Losses"
                            header-align="center">
                            <el-table-column
                                prop="yoy_vs_year_vol_losses_percentage"
                                label="L=D:H"
                                header-align="center"
                                :width="columnWidth"
                                align="right">
                            </el-table-column>
                        </el-table-column>

                    </el-table-column>

                </el-table>

                <div class="p-3 mt-2">
                    <div class="pl-2 pr-3" style="color:#1D7BBB;border: 1px solid #1D7BBB;border-style: dashed;border-radius:10px;background:#F5F5F5;">
                        <ul class="pt-3">
                            <li><b>Volume Losses Pertashop</b> Ytd Mei 2023 sebesar <b>1.8 KL</b> atau <b>-5,21%</b> dari volume penjualan Pertashop.</li>
                            <li><b>Volume Losses SPBU</b> Ytd Mei 2023 sebesar <b>1.048 KL</b> atau <b>-0.13%</b> dari volume penjualan SPBU.</li>
                            <li><b>Volume Losses Konsolidasi</b> Ytd Mei 2023 sebesar <b>1.050 KL</b> atau <b>-0,14%</b>.</li>
                        </ul>
                    </div>
                </div>
            </el-card>

        </div>
        
    </div>
</template>

<script>
import KinerjaKeuangan from '@/components/page/KinerjaKeuangan.js'

export default
{
	extends: KinerjaKeuangan,
	components: { 
		//ReportParamSelect,
	},

	data() {
		return {
            columnWidth : 120,

            options: {
                months:[
                    {value:'1', name: 'Januari'},
                    {value:'2', name: 'Februari'},
                    {value:'3', name: 'Maret'},
                    {value:'4', name: 'April'},
                    {value:'5', name: 'Mei'},
                    {value:'6', name: 'Juni'},
                    {value:'7', name: 'Juli'},
                    {value:'8', name: 'Agustus'},
                    {value:'9', name: 'September'},
                    {value:'10', name: 'Oktober'},
                    {value:'11', name: 'November'},
                    {value:'12', name: 'Desember'},
                ],
                years:[
                    {value:'2021', name: '2021'},
                    {value:'2022', name: '2022'},
                    {value:'2023', name: '2023'},
                ],
            },
            month: '6',
            year: '2023',

            loading: {
                table: false,
            },

            tableData: [
                {
                    type: 'Pertashop',
                    product: 'DEXLITE',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'Pertashop',
                    product: 'PERTAMAX',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'Pertashop Total',
                    product: '',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'SPBU',
                    product: 'BIO PERTAMAX',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'SPBU',
                    product: 'BIO SOLAR',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'SPBU',
                    product: 'BIO SOLAR INDUSTRI',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'SPBU',
                    product: 'DEXLITE',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'SPBU',
                    product: 'PERTALITE',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'SPBU',
                    product: 'PERTALITE KHUSUS',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'SPBU',
                    product: 'PERTAMAX',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'SPBU',
                    product: 'PERATAMAX RACING',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'SPBU',
                    product: 'PERTAMINA TURBO',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'SPBU',
                    product: 'PERTAMINA DEX',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'SPBU',
                    product: 'PREMIUM',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'SPBU',
                    product: 'VIGAS',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'SPBU TOTAL',
                    product: '',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
                {
                    type: 'GRAND TOTAL',
                    product: '',
                    real_current_year_vol_sales: '275.897',
                    real_current_year_vol_losses: '657.823',
                    real_current_year_losses_value: '266.196',
                    real_current_year_losses_percentage: '12%',
                    real_prev_year_vol_sales: '117%',
                    real_prev_year_vol_losses: '48%',
                    real_prev_year_losses_value: '113%',
                    real_prev_year_losses_percentage: '20%',
                    yoy_vs_year_vol_sales:'0',
                    yoy_vs_year_vol_losses:'0',
                    yoy_vs_year_vol_losses_value:'0',
                    yoy_vs_year_vol_losses_percentage:'0',
                }, 
            ]
        }
    },
    watch: {

	}, 
    mounted() {
        this.$emit('childrenRoute');
    },
    methods: {
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 0) {
          if (rowIndex === 0) {
            return { rowspan: 2, colspan: 1 };
          } else if (rowIndex === 3) {
            return { rowspan: 12, colspan: 1 };
          } 
        }
      }
    },
}
</script>